import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', password: '', confirmPassword: '' });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.password) {
      toast.error('Te rugăm să completezi toate câmpurile');
      return;
    }
    if (form.password !== form.confirmPassword) {
      toast.error('Parolele nu se potrivesc');
      return;
    }
    if (form.password.length < 6) {
      toast.error('Parola trebuie să aibă cel puțin 6 caractere');
      return;
    }

    setLoading(true);
    try {
      await register(form.email, form.password, form.name);
      toast.success('Cont creat cu succes!');
      navigate('/');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Înregistrarea a eșuat');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md"
      >
        <div className="text-center mb-12">
          <h1 className="font-heading font-bold text-4xl tracking-tight uppercase text-white" data-testid="register-title">
            CREEAZĂ CONT
          </h1>
          <p className="font-body text-white/50 mt-2">Alătură-te familiei DEPRO KICKS</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <Label className="font-body text-white/70 mb-2 block">Nume Complet</Label>
            <Input
              type="text"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="Numele tău"
              data-testid="name-input"
            />
          </div>
          <div>
            <Label className="font-body text-white/70 mb-2 block">Email</Label>
            <Input
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="emailul@tau.com"
              data-testid="email-input"
            />
          </div>
          <div>
            <Label className="font-body text-white/70 mb-2 block">Parolă</Label>
            <Input
              type="password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="••••••••"
              data-testid="password-input"
            />
          </div>
          <div>
            <Label className="font-body text-white/70 mb-2 block">Confirmă Parola</Label>
            <Input
              type="password"
              value={form.confirmPassword}
              onChange={(e) => setForm({ ...form, confirmPassword: e.target.value })}
              className="bg-[#121212] border-white/10 text-white rounded-none h-12"
              placeholder="••••••••"
              data-testid="confirm-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full bg-[#c00000] text-white hover:bg-[#a00000] rounded-none py-6 font-heading font-bold tracking-wider"
            data-testid="register-submit-btn"
          >
            {loading ? 'SE CREEAZĂ...' : 'CREEAZĂ CONT'}
          </Button>
        </form>

        <p className="text-center mt-8 font-body text-white/50">
          Ai deja cont?{' '}
          <Link to="/login" className="text-[#c00000] hover:underline" data-testid="login-link">
            Conectează-te
          </Link>
        </p>
      </motion.div>
    </div>
  );
};

export default RegisterPage;
